export default function ChevronDownIcon({
  color = "black",
  height = "8",
  width = "12",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.42 0.590088L6 5.17009L10.59 0.590088L12 2.00009L6 8.00009L0 2.00009L1.42 0.590088Z"
        fill={color}
      />
    </svg>
  );
}
